import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
export const NotificationHeader = ({ title, children, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(CatHeading, { variant: "title", slot: "header", className: "text-capitalize", id: "notification-heading", "data-testid": 'drawer-title-notification', "aria-label": title, children: title }), _jsx("div", { slot: "actions", className: "d-flex", children: children })] }));
};
